import { render, staticRenderFns } from "./FormDetalleVenta.vue?vue&type=template&id=973e38f2&scoped=true&"
import script from "./FormDetalleVenta.vue?vue&type=script&lang=js&"
export * from "./FormDetalleVenta.vue?vue&type=script&lang=js&"
import style0 from "./FormDetalleVenta.vue?vue&type=style&index=0&id=973e38f2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "973e38f2",
  null
  
)

export default component.exports